import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EmptyList, Loading } from "../../../components";
import { parseSearchParams } from "../../../helpers/clean-object";

import { SearchShopInput } from "../components";
import { useLazyShops } from "../hooks";
import { ShopsTable } from "../components/shop-table";
import { CardHeader } from "../../../components/cards";

export const Shops = () => {
  const [searchParams] = useSearchParams();

  const [limit, _] = useState(50);
  const [search, { data, loading, fetchMore, error }] = useLazyShops();
  console.log({ data, loading, error });

  useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: parseSearchParams(searchParams),
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;

    return data?.shops?.results?.length && data?.shops?.results?.length > 0 ? (
      <ShopsTable
        iData={
          data?.shops?.results?.map((shop) => ({
            shop: { id: shop?.id, name: shop?.name },
            phone: shop.phone,
            city: shop.city,
            membersCount: shop.membersCount,
            adsCount: shop.adsCount,
          })) || []
        }
      />
    ) : (
      <EmptyList text="Aucun Résultat" />
    );
  };

  return (
    <>
      <div className="main-container">
        <SearchShopInput {...parseSearchParams(searchParams)} />

        <div className="card mb-2">
          <CardHeader
            title="Liste des professionnels"
            subtitle={`${data?.shops?.total} résultats`}
          />
          {renderList()}
        </div>

        {data?.shops?.hasMore && (
          <div className="flex flex-wrap -mx-4 items-center justify-between">
            <div className="w-full lg:w-1/3 px-4 flex items-center mb-4 lg:mb-0"></div>
            <div className="w-full lg:w-auto px-4 flex items-center justify-center">
              <div
                className=" cursor-pointer inline-flex items-center justify-center px-2 h-8 text-xs text-white bg-indigo-500 rounded"
                onClick={() => {
                  fetchMore({
                    variables: {
                      offset: data?.shops?.results?.length,
                      limit,
                      where: parseSearchParams(searchParams),
                    },
                  });
                }}
              >
                Charger Plus
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
